module.exports = __webpack_public_path__ + "1-12.png?48cc9dd0c36179510b2a764e573e1d00";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-12.png
// module id = 89
// module chunks = 0